<template>
  <div>
    <portal :to='titleLocation'>
      <h1 class='text-2xl font-semibold px-8 py-8'>Create Entity</h1>
    </portal>
    <component :is='entityDataEditMode' />
    <portal :to='actionButtonsLocation'>
      <div class='flex flex-row justify-between w-full bg-gray-100 px-8 pr-8 py-4 text-sm shadow-lg'>
        <button
          v-if='addingEntity'
          class='border px-6 h-12 text-sm text-white rounded-md font-bold'
          style='background-color: #223645;'
          :disabled='!drilldownEntityRequiredFieldsValid'
          @click='createNewEntity'>추가</button>
        <button
          v-else
          class='border px-6 h-12 text-sm text-white rounded-md font-bold'
          style='background-color: #223645;'
          :disabled='!drilldownEntityRequiredFieldsValid'
          @click='submitEditEntity'>저장</button>
        <div v-if='canDelete'>
          <button v-if='!showConfirmDelete' name='show-confirm-delete-btn' class='p-3 text-red-700 text-sm border border-transparent hover:border-red-400 rounded-md' @click='showConfirm'>Delete <span class='font-semibold'>{{drilldownEntityName}}</span></button>
          <div v-else class='p-8 text-center mt-4 border rounded-md'>
            <h4 class='mb-8'><span class='font-semibold'>{{drilldownEntityName}}</span> 삭제하시겠습니까?</h4>
            <button @click='hideConfirm' class='py-3 px-6 rounded-md text-sm border border-gray-400 mr-4 hover:border-gray-800'>취소</button>
            <button @click='confirmDelete' name='confirm-delete-btn' class='p-3 text-red-700 text-sm border border-transparent hover:border-red-400 rounded-md'>삭제</button>
          </div>
        </div>
      </div>
    </portal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import EntityDataEditInvestmentModeFields from '@/views/entities/EntityDataEditInvestmentModeFields.vue'

export default {
  name: 'EntityDataEdit',
  components: {
    EntityDataEditInvestmentModeFields,
  },
  props: [
    'displayInModal'
  ],
  data () {
    return {
      showConfirmDelete: false,
    }
  },
  computed: {
    ...mapGetters('entities', [
      'drilldownEntityName',
      'drilldownEntityId',
      'drilldownEntityRequiredFieldsValid',
    ]),
    ...mapState('entities', ['drilldownEntity']),
    canDelete () {
      return this.drilldownEntityId > 0 // requested by Time
      // return false // TODO (Hana - 2021.7.7): need to check ot see if has associated investments
    },
    addingEntity () {
      return this.displayInModal // for now, if we are using the modal, it is adding
    },
    entityDataEditMode () {
      return 'entity-data-edit-investment-mode-fields'
    },
    actionButtonsLocation () {
      return (this.displayInModal) ? 'modal-footer' : 'sidepanel-footer'
    },
    titleLocation () {
      return 'modal-header'
    },
  },
  methods: {
    ...mapActions([
      'sidepanelClose'
    ]),
    ...mapActions('entities', [
      'deleteEntity',
      'updateEntity',
      'createEntity',
    ]),
    createNewEntity () {
      this.createEntity().then(resp => {
        this.doneEditing(resp)
      })
    },
    cancelEditing () {
      this.doneEditing(this.drilldownEntity)
    },
    confirmDelete () {
      this.deleteEntity(this.drilldownEntityId).then(() => {
        this.doneEditing(this.drilldownEntity)
      })
    },
    doneEditing (resp) {
      this.$emit('done-editing', resp)
    },
    hideConfirm () {
      this.showConfirmDelete = false
    },
    showConfirm () {
      this.showConfirmDelete = true
    },
    submitEditEntity () {
      this.updateEntity().then(() => {
        this.doneEditing(this.drilldownEntity)
      })
    },
  },
}
</script>

<style lang='scss' scoped>
button:disabled,
button[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
